<template>
  <v-app id="mfaSet">
    <v-card
      color="lighten-1"
      flat
    >
      <!-- 秘密鍵 -->
      <v-text-field
        v-model="tmpCopySercet"
        style="display:none"
      />
      <div v-if="mfaflg">
        <!-- モバイルデバイス判定 -->
        <div v-if="mobileFlg">
          <v-row
            dense
            max-width="100"
          >
            <!-- モバイルデバイス -->
            <v-col
              cols="12"
              align="center"
            >
              <span>
                秘密鍵管理アプリをスマートフォンにインストールしてから「秘密鍵管理アプリを起動」ボタンを押下してください。
              </span>
            </v-col>
            <v-col
              cols="12"
              align="center"
            >
              <v-btn 
                :href="tmpCopySercet"
                color="success"
                @click="inputTotpFlg = true;"
              >
                秘密鍵管理アプリを起動
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              align="center"
            >
              <div v-if="inputTotpFlg">
                <!-- QRコード読み込み後に表示 モバイル用 -->
                <v-row
                  dense
                  max-width="100"
                >
                  <!-- ワンタイムパスワード -->
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="1"
                    xl="1"
                  />
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="2"
                    xl="2"
                  >
                    <span>
                      ワンタイムパスワード<required-mark />
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="6"
                    xl="6"
                  >
                    <v-text-field
                      v-model="mfaOnetimepass"
                      required
                      counter="6"
                      maxlength="6"
                      :rules="[v => !!v || &quot;ワンタイムパスワードは必須です&quot;]"
                      hint="秘密鍵管理用のスマートフォンアプリに表示された6桁の数値を入力してください。時間経過によりワンタイムパスワードは更新されます。"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="3"
                    xl="3"
                  />
                  <v-col
                    cols="12"
                    align="center"
                  >
                    <v-btn
                      color="primary"
                      :loading="loadingOneTime"
                      :disabled="loadingOneTime"
                      @click="clickNext();"
                    >
                      ワンタイムパスワードを送信
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row
            dense
            max-width="100"
          >
            <!-- PC -->
            <v-col
              cols="12"
              align="center"
            >
              <span>
                秘密鍵管理用のスマートフォンアプリをインストールしてからQRコード生成ボタンを押下してください。
              </span>
            </v-col>
            <v-col
              cols="12"
              align="center"
            >
              <span>
                QRコードが表示されますので秘密鍵管理用のスマートフォンアプリのカメラ機能で読み込ませてください。
              </span>
            </v-col>
            <v-col
              cols="12"
              align="center"
            >
              <v-btn
                color="success"
                @click="displayQrCode();"
              >
                QRコード生成
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              align="center"
            >
              <div v-if="inputTotpFlg">
                <!-- QRコード読み込み後に表示 PC用 -->
                <v-row
                  dense
                  max-width="100"
                >
                  <!-- ワンタイムパスワード -->
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="1"
                    xl="1"
                  />
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="2"
                    xl="2"
                  >
                    <span>
                      ワンタイムパスワード<required-mark />
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="6"
                    xl="6"
                  >
                    <v-text-field
                      v-model="mfaOnetimepass"
                      required
                      counter="6"
                      maxlength="6"
                      :rules="[v => !!v || &quot;ワンタイムパスワードは必須です&quot;]"
                      hint="秘密鍵管理用のスマートフォンアプリに表示された6桁の数値を入力してください。時間経過によりワンタイムパスワードは更新されます。"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    xs="12"
                    sm="12"
                    md="12"
                    lg="3"
                    xl="3"
                  />
                  <v-col
                    cols="12"
                    align="center"
                  >
                    <v-btn
                      color="primary"
                      :loading="loadingOneTime"
                      :disabled="loadingOneTime"
                      @click="clickNext();"
                    >
                      ワンタイムパスワードを送信
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row
          dense
          max-width="100"
        >
          <v-col
            cols="12"
            align="center"
          >
            <!-- ワンタイムパスワード認証説明を表示 -->
            <mfa-description />
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row
          dense
          max-width="100"
        >
          <v-col
            cols="12"
            align="center"
          >
            <span>ワンタイムパスワード認証は無効です。この設定は後からでも変更できます。</span>
          </v-col>
          <v-col
            cols="12"
            align="center"
          >
            <v-btn
              color="primary"
              :loading="loadingOneTime"
              :disabled="loadingOneTime"
              @click="clickNext();"
            >
              次へ
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>

import MfaDescription from './MfaDescription.vue';
import QRCode from 'qrcode';
import Amplify from '../amplify_com.js';
import MsgDlg from './MsgDlg.vue';
import RequiredMark from './RequiredMark.vue';

export default {
  name: 'MfaSetting',
  components: {
    'msg-dlg': MsgDlg,
    'mfa-description': MfaDescription,
    'required-mark': RequiredMark,
  },
  props: {
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    userId: {
      type: String,
      required: false,
      default: '',
    },
    userPassCf: {
      type: String,
      required: false,
      default: '',
    },
    mfaflg: Boolean,
    mobileFlg: Boolean,
  },
  data: () => ({
    inputTotpFlg: false,
    mfaOnetimepass: '',
    tmpCopySercet: '',
    loadingOneTime: false,
  }),
  methods: {
    init : async function() {
      let _this = this;
      // 事前にシークレットを発行しておく
      await _this.getSercet().then(secretCode => {
        // TOTPコード生成
        var data = _this.editOtpauth(secretCode);
        _this.tmpCopySercet = data;
      }).catch(err => {
        _this.$refs.MsgDlg.showModalError(Amplify.GetJaErrMsg(err));
      });
    },
    clickNext() {
      this.loadingOneTime = true;
      const mfaSettingResult = {
        mfaOnetimepass : this.mfaOnetimepass,
        index : this.index,
      };
      this.$emit('clickNext', mfaSettingResult);
    },
    setLoadingOneTime(){
      this.loadingOneTime = false;
    },
    displayQrCode :async function() {
      let _this = this;
      // TOTPコード生成
      QRCode.toDataURL(_this.tmpCopySercet, function (err, url) {
        if (err){
          _this.$refs.MsgDlg.showError('QRコードの生成に失敗しました。もう一度生成ボタンを押下してください。');
          return;
        }
        _this.$refs.MsgDlg.showModalSuccess('QRコードの生成に成功しました。', url, 500);
        _this.inputTotpFlg = true;
      });
    },
    getSercet: async function() {
      let _this = this;
      let _user = null;
      let _secretCode = null;
      await Amplify.Auth.signIn(
        {
          username : _this.userId,
          password : _this.userPassCf,
          validationData: {
            input_username: _this.userId,
          },
        }
      ).then(user => {
        _user = user;
      }).catch(err => {
        throw err;
      });

      await Amplify.Auth.setupTOTP(
        _user
      ).then(secretCode => {
        _secretCode = secretCode;
      }).catch(err => {
        throw err;
      });
      return _secretCode;
    },
    editOtpauth(secretCode) {
        var issuer = 'Epson-Weplat-クラウドフォルダー'; // サービス名称
        issuer = encodeURIComponent(issuer);
        return "otpauth://totp/" + issuer + ":" + this.userId + "?secret=" + secretCode + "&issuer=" + issuer + "&algorithm=SHA1&digits=6&period=30";
    }
  }
};
</script>

<style>
</style>